"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTextGetter = void 0;
function defaultTextGetter(option) {
    if (typeof option === 'object' && typeof (option === null || option === void 0 ? void 0 : option['label']) === 'string') {
        return option['label'];
    }
    if (typeof option === 'object' && typeof (option === null || option === void 0 ? void 0 : option['text']) === 'string') {
        return option['text'];
    }
    console.error('Combobox error: You must define "textGetter" property or provide  "text"|"label" as string field in option data');
    return '';
}
exports.defaultTextGetter = defaultTextGetter;
//# sourceMappingURL=defaultTextGetter.js.map